/*
 * Filename: /Users/jangabrielledelemos/mwell-web-frontend/src/modules/onboard-user-profile/PhilHealth.js
 * Path: /Users/jangabrielledelemos/mwell-web-frontend
 * Created Date: Tuesday, August 19th 2025, 4:04:30 pm
 * Author: Jan de Lemos
 *
 * Copyright (c) 2025 MWELL
 */

import React, { Component } from "react";
import UI from "../../shared/Components/UI/js";
import { View } from "../../shared/custom-react-native";
import { Checkbox } from "../_components/InputForm";
import "./css.css";

export default class PhilHealthForm extends Component {
  render() {
    const _this = this.props._this;
    const {
      // height,
      width,
      // isMobile,
      // file_prc_license_path,
      file_signature_path,
      file_cor_path,
      isPhilHealthAccredited,
    } = _this.state;

    const checkboxText =
      this.props.text || "Are you Accredited with PhilHealth?";

    const row_width = width > 1000 ? width - 400 : "100%";

    // default to "No" if undefined/null
    const normalizedIsAccredited = isPhilHealthAccredited ?? false;

    return (
      <UI.Column style={{ marginBottom: 10 }} _this={_this}>
        <div _this={_this} className="flex flex-col gap-3 w-full mt-3">
          <UI.Row
            style={{ width: row_width, justifyContent: "space-between" }}
            _this={_this}
            breakpoint={1000}
          >
            <View style={{ flex: 1 }}>
              <span
                className="font-semibold"
                style={{
                  color: UI.colors.primary,
                  fontSize: "15px",
                  fontWeight: "500",
                  fontFamily: "Poppins",
                }}
              >
                {checkboxText}
              </span>
              {UI.box(20)}

              <View style={{ flexDirection: "row", alignItems: "center" }}>
                <Checkbox
                  _this={_this}
                  text={"Yes"}
                  onClick={() => {
                    _this.setState({
                      isPhilHealthAccredited: true,
                    });
                    if (this.props.onUpdate) {
                      this.props.onUpdate(true);
                    }
                  }}
                  is_checked={normalizedIsAccredited === true}
                  color={"#2E2E2E"}
                />
                <View style={{ width: 50 }}></View>
                <Checkbox
                  _this={_this}
                  text={"No"}
                  onClick={() => {
                    _this.setState({
                      isPhilHealthAccredited: false,
                    });
                    if (this.props.onUpdate) {
                      this.props.onUpdate(false);
                    }
                  }}
                  is_checked={normalizedIsAccredited === false}
                  color={"#2E2E2E"}
                />
              </View>
            </View>
          </UI.Row>
        </div>
      </UI.Column>
    );
  }
}
